import api from '@pray/shared/utils/api';
import type { ListResponse } from '@pray/shared/utils/api/types/response';

import type {
  OrganizationServiceTimeResponse,
  UpdateOrganizationServicesParams,
  UpdateOrganizationServicesRequest,
} from './types';

export async function updateOrganizationServices(organizationId: string, params: UpdateOrganizationServicesParams) {
  const url = `/web/studio/organizations/${organizationId}/services`;

  const body: UpdateOrganizationServicesRequest = {
    create: params.create ?? [],
    update: params.update ?? [],
    delete: params.delete ?? [],
  };

  const response = await api.executePutRequest<ListResponse<OrganizationServiceTimeResponse>>(url, body);

  return response;
}
